{
  "MaxPartitions": "Somente as primeiras partições {} serão verificadas para dispositivos. Ative \"Relatórios para toda a telefonia\" nas configurações da Telsys para verificar todas as partições.",
  "NAME": "ErrorLanguage",
  "Error_Title": "Desculpe",
  "Error_SubTitle": "Não conseguimos encontrar a página que você está procurando.",
  "Error_Message": "A página ou recurso pode ter sido movido, atualizado ou excluído. \n \n Ou você pode ter digitado o endereço da web incorretamente. Verifique o endereço e a ortografia.",
  "Error_PageTitle": "Desculpe, não conseguimos encontrar a página que você está procurando.",
  "Validations_MustBeUnique": "O valor deve ser único"
}